import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackCallAnyway, trackPopupShown, trackWriteMessageClick } from './tracking';
import { closeNotAvailableModal } from '../../actions/notAvailableModal';
import { NotAvailablePopup } from '../../components/NotAvailablePopup';
import { useCall } from '../../hooks/useCall';
import { useChats } from '../../hooks/useChats';
import { selectNotAvailableModal } from '../../selectors/notAvailableModal';
import { selectUser } from '../../selectors/user';
import { IUserAuthenticated } from '../../types/user';
import { TRecommendation } from '../../types/recommendation';

export const NotAvailablePopupContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { isOpen, offer, phone } = useSelector(selectNotAvailableModal);
  const { agentAvailability } = offer || {};
  const deviceType = useDeviceType();
  const user = useSelector(selectUser) as IUserAuthenticated;
  const { isEnabled, openChat } = useChats(offer);
  const { produceCallAfterAuth } = useCall(offer || ({} as TRecommendation));

  const defaultMessage = React.useMemo(
    () => `Здравствуйте, пожалуйста свяжитесь со мной ${(user.phones && user.phones[0]) || ''}`,
    [user],
  );

  const onWriteMessage = React.useCallback(() => {
    if (!offer) {
      return;
    }

    dispatch(closeNotAvailableModal());

    openChat({ defaultMessage, customTrackClick: () => trackWriteMessageClick(offer, deviceType) });
  }, [offer, dispatch, openChat, defaultMessage, deviceType]);

  const onCallAnyway = React.useCallback(() => {
    if (!offer) {
      return;
    }

    trackCallAnyway(offer);
    dispatch(closeNotAvailableModal());

    produceCallAfterAuth(phone, true);
  }, [offer, dispatch, phone, produceCallAfterAuth]);

  const onClose = React.useCallback(() => {
    dispatch(closeNotAvailableModal());
  }, [dispatch]);

  const onShow = React.useCallback(() => {
    if (!offer) {
      return;
    }

    trackPopupShown(offer);
  }, [offer]);

  if (!offer || !isOpen || !agentAvailability) {
    return null;
  }

  const { title, message, available } = agentAvailability;

  if (available || !title || !message) {
    return null;
  }

  return (
    <NotAvailablePopup
      onClose={onClose}
      onCallAnyway={onCallAnyway}
      onWriteMessage={onWriteMessage}
      onShow={onShow}
      title={title}
      message={message}
      isChatEnabled={isEnabled}
    />
  );
};
